/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierFreeJupyterEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_FREE_JUPYTER_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierFreeJupyterEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierFreeJupyterEnabledSettingParser.decode(input).map(res => new TierFreeJupyterEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierFreeJupyterEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierFreeJupyterEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierFreeJupyterEnabledSettingParser.schema();
    }
}
